(() => {
  'use strict';
  if (window.AvonticQualifiedFit) return;
  const contexts = () => Array.from(document.querySelectorAll('[data-av-qualified-fit-config]')).flatMap(node => {
    try {
      const config = JSON.parse(node.textContent);
      const form = document.getElementById(config.formId);
      if (!form) return [];
      const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(config.formId)}"]`);
      let variant;
      try { variant = JSON.parse(picker?.querySelector('script[data-variant]')?.textContent || 'null'); } catch (_) {}
      const selected = variant?.options?.[config.optionIndex] ?? config.currentOption;
      return [{config,form,picker,variant,blocked:config.blockedOptions.includes(selected)}];
    } catch (_) { return []; }
  });
  function render() {
    contexts().forEach(c => {
      c.form.dataset.avQualifiedFit = c.blocked ? 'blocked' : 'clear';
      const notice = c.form.querySelector('[data-av-qualified-fit-notice]');
      if (notice) notice.hidden = !c.blocked;
      const buttons = Array.from(document.querySelectorAll('[data-av-atc-control]')).filter(b => c.form.contains(b) || b.getAttribute('form') === c.config.formId || b.closest('[form]')?.getAttribute('form') === c.config.formId);
      buttons.forEach(button => {
        if (c.blocked) {
          button.dataset.avQualifiedDisabled = 'true';
          button.disabled = true;
          button.setAttribute('aria-disabled','true');
          if (button.textContent !== c.config.blockedLabel) button.textContent = c.config.blockedLabel;
        } else if (button.dataset.avQualifiedDisabled === 'true') {
          delete button.dataset.avQualifiedDisabled;
          if (c.variant?.available) {
            button.disabled = false;button.removeAttribute('aria-disabled');
            button.textContent = c.form.querySelector('buy-buttons')?.dataset.avAtcLabelAvailable || 'Add to cart';
          }
        }
      });
      c.form.querySelectorAll('[data-av-payment-wrapper]').forEach(wrapper => {
        if(c.blocked){wrapper.dataset.avQualifiedHidden='true';wrapper.hidden=true;wrapper.inert=true;}
        else if(wrapper.dataset.avQualifiedHidden==='true'){
          delete wrapper.dataset.avQualifiedHidden;
          if(c.variant?.available&&c.form.dataset.avPurchaseFit==='selected'&&!wrapper.hasAttribute('data-av-inventory-hidden')){wrapper.hidden=false;wrapper.inert=false;}
        }
      });
    });
  }
  function stop(event,c){event.preventDefault();event.stopImmediatePropagation();const notice=c.form.querySelector('[data-av-qualified-fit-notice]');if(notice){notice.hidden=false;notice.focus({preventScroll:true});notice.scrollIntoView({block:'center',behavior:'auto'});}}
  document.addEventListener('submit',event=>{const c=contexts().find(c=>c.form===event.target&&c.blocked);if(c)stop(event,c);},true);
  document.addEventListener('click',event=>{const b=event.target.closest?.('[data-av-atc-control],.shopify-payment-button');if(!b)return;const c=contexts().find(c=>c.blocked&&(c.form.contains(b)||b.getAttribute('form')===c.config.formId||b.closest('[form]')?.getAttribute('form')===c.config.formId));if(c)stop(event,c);},true);
  let queued=false;const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;render();});};
  ['variant:change','product:rerender','shopify:section:load','avontic:pdp-fit-verification'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('change',schedule,true);
  const start=()=>{render();new MutationObserver(records=>{if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1)))schedule();}).observe(document.body,{childList:true,subtree:true});};
  window.AvonticQualifiedFit=Object.freeze({version:'2026-09-30.1'});
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',start,{once:true}):start();
})();
